import initialState from './initialState';
import { LoadingStatusEnum } from '../../../constants/enums';

export const GetCigarProductionPlansReducer = {
  pending: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => ({
    ...state,
    list: action.payload.data || [],
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
};

export const GetCigarProductionPlanSummariesReducer = {
  pending: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => ({
    ...state,
    summaries: action.payload.data || [],
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
};

export const CreateCigarProductionPlanReducer = {
  pending: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: [...state.list, data],
      mutationLoading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Failed,
  }),
};

export const UpdateCigarProductionPlanReducer = {
  pending: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: state.list.map((plan) => {
        if (plan._id === data._id) {
          return data;
        }

        return plan;
      }),
      mutationLoading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Failed,
  }),
};

export const DeleteCigarProductionPlanReducer = {
  pending: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: state.list.filter((plan) => plan._id !== data._id),
      mutationLoading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Failed,
  }),
};

export const TakeInWorkCigarProductionPlanReducer = {
  pending: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      list: state.list.map((plan) => {
        if (plan._id === data._id) {
          return data;
        }
        return plan;
      }),
      mutationLoading: LoadingStatusEnum.Succeeded,
    };
  },
  rejected: (state) => ({
    ...state,
    mutationLoading: LoadingStatusEnum.Failed,
  }),
};

export const ResetCigarProductionPlansStateReducer = () => initialState;
